import { render } from "./Experience.vue?vue&type=template&id=88bf6df2&scoped=true"
import script from "./Experience.vue?vue&type=script&lang=js"
export * from "./Experience.vue?vue&type=script&lang=js"

import "./Experience.vue?vue&type=style&index=0&id=88bf6df2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88bf6df2"]])

export default __exports__